var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('EditContentSlide'),_c('NewContentSlide'),_c('EditTags'),_c('ContentBrowser',{attrs:{"isEditable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }